module.exports = __webpack_public_path__ + "static/media/errorIcon.85ca0b06.svg";